<template>
  <div class="package-export-registration-form-page">
    <div v-if="forms.length">
      <div v-for="(form, index) in formPresenters" :key="`${form.name}-${index}`" class="form-card">
        <div class="d-flex justify-content-between">
          <p>No.</p>
          <div class="label date">
            <p class="en">Date</p>
            <p class="th">วันที่</p>
          </div>
        </div>
        <div class="citizen-card">
          <img :src="form.citizenImageURL" />
        </div>
        <div class="form-input">
          <div class="label">
            <p class="en">Name - Surname</p>
            <p class="th">ชื่อ - นามสกุล</p>
          </div>
          <div class="placeholder">{{ form.name }}</div>
        </div>
        <div class="house-info">
          <div class="form-input">
            <div class="label">
              <p class="en">House No.</p>
              <p class="th">บ้านเลขที่</p>
            </div>
            <div class="placeholder">{{ form.houseNo }}</div>
          </div>
          <div class="form-input">
            <div class="label">
              <p class="en">Project Name</p>
              <p class="th">โครงการ</p>
            </div>
            <div class="placeholder">{{ form.projectName }}</div>
          </div>
        </div>
        <div class="form-input">
          <div class="label">
            <p class="en">Signature</p>
            <p class="th">ลายเซ็น</p>
          </div>
          <div class="placeholder"></div>
        </div>
      </div>
    </div>
    <div v-else>
      <h5 class="text-center p-4">ไม่มีข้อมูล</h5>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";

export default {
  data() {
    const forms = [];

    return {
      forms
    };
  },
  computed: {
    formPresenters() {
      return this.forms
        .filter(({ name }) => !!name)
        .map(({ name, home, citizen_card_image_url: citizenCardImageUrl }) => ({
            name,
            houseNo: home.address_no,
            citizenImageURL: citizenCardImageUrl,
            projectName: home.project_code
          }));
    }
  },
  mounted() {
    this.setup();
  },
  beforeDestroy() {
    this.teardown();
  },
  methods: {
    async setup() {
      this.setupView();
      await this.setupData();
    },
    setupView() {
      document.body.classList.add("paper-a4");
    },
    async setupData() {
      const response = await baanRueJaiClient.admin.subscriptions.subscribers.getPackageRegistrationForms(
        this.$route.params.id,
        this.$route.query
      );

      this.forms = response.data.result;
    },
    teardown() {
      document.body.classList.remove("paper-a4");
    }
  }
};
</script>

<style lang="scss" scoped>
@page {
  size: A4;
  margin: 10mm;
}

@media print {
  body.paper-a4 {
    width: 210mm;
    height: 297mm;
  }
}

body.paper-a4 {
  overflow: auto;
  height: auto;

  #app {
    height: auto;
  }
  .form-card {
    .label {
      > .en,
      > .th {
        line-height: 1.4;
      }

      > .en {
        font-size: 0.5em;
      }
      > .th {
        font-size: 0.75em;
      }
    }

    .form-input {
      display: grid;
      grid-template-columns: 20mm 1fr;
      grid-gap: 2.5mm;
      align-items: center;

      padding: 2.5mm 0;

      > .placeholder {
        height: 8mm;

        font-size: 0.75em;
        font-weight: bold;
        line-height: 8mm;

        &:empty {
          border-bottom: 1px solid black;
        }
      }
    }

    .citizen-card {
      margin-top: 5mm;
      padding: 5mm 0;
      border-top: 1px solid black;
      border-bottom: 1px solid black;
    }

    .citizen-card > img {
      width: 100%;
    }

    .house-info {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 2.5mm;

      > .form-input:last-child {
        grid-template-columns: 15mm 1fr;
      }
    }

    .date {
      margin-right: 20mm;
    }
  }
}

.package-export-registration-form-page {
  text-align: left;

  .form-card {
    padding: 5mm;

    display: inline-block;
    width: 260mm;
    page-break-inside: avoid;
  }
}
</style>
